module.exports = __webpack_public_path__ + "img/11.e6e5127d.jpg";